import { render, staticRenderFns } from "./TravelTranList.vue?vue&type=template&id=05584947&"
import script from "./TravelTranList.vue?vue&type=script&lang=js&"
export * from "./TravelTranList.vue?vue&type=script&lang=js&"
import style0 from "./TravelTranList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelTranList.vue"
export default component.exports